import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import GlobalStyles from './styles/globalStyles';
import theme from './styles/theme';
import HomePage from './pages/HomePage';
import StockAnalysisPage from './pages/StockAnalysisPage';
import CyberdefensePage from './pages/CyberdefensePage';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/stock-analysis" element={<StockAnalysisPage />} />
          <Route path="/cyberdefense" element={<CyberdefensePage />} />
          {/* Redirect any unknown routes to home */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Router>
    </ThemeProvider>
  )
}

export default App
